import commonRouter from './commonRouter';

export default commonRouter;
